import React from 'react';
import './App.css';
import './Input'
import Input from "./Input";
import axios from 'axios';

interface AppState {
  text: string;
  imageHtml: string | null;
  error: string | null;
  waiting: boolean;
  debug: boolean;
}

class App extends React.Component<any, AppState>{

  constructor(props: any) {
    super(props);
    this.state = {
      text: '',
      error: null,
      imageHtml: null,
      waiting: false,
      debug: false
    }
    this.handleTextChange = this.handleTextChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this._wrapMarkup = this._wrapMarkup.bind(this);
    this._convert = this._convert.bind(this);
  }

  handleTextChange(value: string) {
    this.setState({
      text: value
    })
  }

  async _convert() {
    this.setState({
      error: null
    })
    try {
      const response = await axios.post('https://plantuml.paul-blaesi.de/svg', this.state.text, {
        headers: {
          'Content-Type': 'text/plain'
        },
        validateStatus: status => {
          return status !== 404 && status < 500;
        }
      });
      if (response.status >= 400) {
        this.setState({
          error: `Got status ${response.status} (${response.statusText})`
        });
      }
      this.setState({
        imageHtml: response.data
      });
    } catch (error) {
      this.setState({
        error: `Error sending conversion request: ${error.message}`,
        imageHtml: null
      });
    } finally {
      this.setState({
        waiting: false
      })
    }
  }

  onClick() {
    this.setState({
      waiting: true
    });
    this._convert();
  }

  _wrapMarkup() {
    return {
      __html: this.state.imageHtml || ''
    };
  }

  render() {
    return (
      <div className="App">
        <div id="main">
          <Input text={this.state.text} onTextChange={this.handleTextChange} rows={20} columns={60} />
          <button onClick={this.onClick}>&gt;</button>
          <div id="output" dangerouslySetInnerHTML={this._wrapMarkup()}/>
        </div>
        <div id="error-area" className={this.state.error ? 'error' : 'clean'}>
          {this.state.error}
        </div>
        <div id="waiting-indicator" className={this.state.waiting ? 'waiting' : 'invisible'}>
          <span>Waiting...</span>
        </div>
        <div id="debug-area" className={this.state.debug ? 'visible' : 'invisible'}>
          <span>{JSON.stringify(this.state)}</span>
        </div>
      </div>
    );
  }
}

export default App;
